import React from "react";

const Footer = () => (
	<footer className="bg-[#031B4E] text-white py-4 text-center">
		<p>&copy; 2025 LightYear Telecom Enterprise Limited</p>
	</footer>
);

export default Footer;
